import React, { useEffect, useRef, useState } from 'react';
import { updateSurveyImage } from '../actions';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

const ImagePicker = ({ imgBlob, kitId, onImageUpdate }) => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("userInfo");
    const { id } = useParams();
    const userInfo = JSON.parse(token);
    const [image, setImage] = useState(imgBlob);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);
    const MAX_FILE_SIZE_KB = 100;
    const MAX_FILE_SIZE = MAX_FILE_SIZE_KB * 1024;

    useEffect(() => {
        if (imgBlob) {
            setImage(imgBlob.startsWith('data:image') ? imgBlob : `data:image/png;base64,${imgBlob}`);
        }
    }, [imgBlob]);

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > MAX_FILE_SIZE) {
            alert(`Image size should not exceed ${MAX_FILE_SIZE_KB}KB. Selected image is ${(file.size / 1024).toFixed(2)}KB.`);
            return;
        }

        const reader = new FileReader();
        reader.onloadend = async () => {
            const base64Image = reader.result;
            setImage(base64Image);
            setLoading(true);

            try {
                const response = await dispatch(updateSurveyImage(kitId, base64Image));
                if (response?.message === "Image updated successfully!") {
                    onImageUpdate(base64Image);
                }
            } catch (error) {
                console.error("Image update failed:", error);
            } finally {
                setLoading(false);
            }
        };

        reader.readAsDataURL(file);
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="image-picker">
            <div className="profile-pic" onClick={handleImageClick}>
                {loading ? (
                    <span>Uploading...</span> // You can replace this with a spinner component
                ) : image ? (
                    <img src={image} alt="Pet" />
                ) : (
                    <span>Click to add photo</span>
                )}
            </div>
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleImageChange}
                style={{ display: 'none' }}
            />
        </div>
    );
};

export default ImagePicker;